import { IntegrationAgentNames } from '@constants';
import { postApiGalaxyServer } from 'services';
import { Realm } from 'types';
import ApiClientManager from 'core/apiClient';

export interface CreateBakIntegrationsPayload {
  teamName: string;
  integrationId: number;
  realmId: Realm['realm_id'];
  s3BucketName: string;
  serviceName: IntegrationAgentNames;
  metadata?: any;
  /** Optional tenant for header override */
  tenant?: string;
}

export type CreateBakIntegrationsSuccessResponse = {
  response: Record<string, unknown>;
  status: number;
  message: string;
};

export interface CreateBakIntegrationsErrorResponse {
  error: string;
  message: string;
  statusCode: number;
}

export const createBakIntegrationsApi = ({
  params: body,
  token,
  config = {},
}: BaseApiParams<CreateBakIntegrationsPayload>) => {
  // Build custom headers if tenant/realmId are provided to override global cache
  const customHeaders =
    body.tenant && body.realmId
      ? ApiClientManager.buildUrlHeaders({ tenantName: body.tenant, realmId: body.realmId })
      : undefined;

  // Remove header-only field from the request body (tenant is only for headers)
  const { tenant: _tenant, ...bodyParams } = body;

  return postApiGalaxyServer(
    `/bak-integrations`,
    bodyParams,
    { ...config, ...(customHeaders && { headers: customHeaders }) },
    token,
  );
};
